import React from "react";

import { Switch, type SwitchProps } from "../switch/Switch";
import { HelpPopupTooltip } from "../tooltip/HelpPopupTooltip";

export interface LabeledSwitchProps extends SwitchProps {
	label: string;
	id?: string;
	help?: string;
}

export const LabeledSwitch: React.FC<LabeledSwitchProps> = ({
	label,
	id = label.replaceAll(" ", "_"),
	...restProps
}) => (
	<div className="flex items-center justify-between">
		<label className="flex cursor-pointer items-center text-gray-800" htmlFor={id}>
			{label}
			{restProps.help && <HelpPopupTooltip className="ml-2 flex h-5 items-center" content={restProps.help} />}
		</label>

		<Switch id={id} {...restProps} />
	</div>
);
